import { useMemo } from 'react';
import * as React from 'react';
import styled, { css } from 'styled-components';

import { chartConfig } from '../../data/mock-chart';

const Wrapper = styled.div<{ $small: boolean }>`
  display: flex;
  flex: 1 1 auto;
  padding: 10px;
  position: relative;
  min-height: 150px;

  ${({ $small }) =>
    $small &&
    css`
      padding: 0;
    `}
`;

const ChartInner = styled.div<{ $isGrouped: boolean }>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-end;
  position: relative;
  z-index: 0;

  ${({ $isGrouped }) =>
    $isGrouped &&
    css`
      gap: 3px;
    `}
`;

const Group = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;
  position: relative;
  z-index: 0;
  flex: 1 1 auto;

  > div {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex: 1 1 auto;
    height: 100%;

    span {
      display: flex;
      flex: none;
      width: 100%;
      height: auto;

      &:nth-child(1) {
        background-color: #436d9e;
      }

      &:nth-child(2) {
        background-color: #f47c1a;
      }

      &:nth-child(3) {
        background-color: #e15251;
      }

      &:nth-child(4) {
        background-color: #67aea9;
      }

      &:nth-child(5) {
        background-color: #4a9842;
      }

      &:nth-child(6) {
        background-color: #ebc335;
      }

      &:nth-child(7) {
        background-color: #a96e98;
      }
    }
  }
`;

const GridLines = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 20px;
  right: 15px;
  bottom: 20px;
  left: 15px;
  justify-content: space-between;
  opacity: 0.6;
`;

const GridLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e1e8ed;
`;

interface ChartProps {
  grouped?: boolean;
  small?: boolean;
}

export const Chart: React.ComponentType<ChartProps> = React.memo(
  ({ grouped = false, small = false }) => {
    const chartContents = useMemo(() => {
      return (
        <ChartInner $isGrouped={grouped}>
          {chartConfig.map((month, indx) => (
            <Group key={indx}>
              {month.weeks.map((weekData, i) => (
                <div
                  key={i}
                  style={{
                    height: `${month.height}`
                  }}>
                  <>
                    {weekData.map((wk, i) => (
                      <span
                        key={i}
                        style={{
                          height: `${wk}`
                        }}
                      />
                    ))}
                  </>
                </div>
              ))}
            </Group>
          ))}
        </ChartInner>
      );
    }, [grouped]);

    return (
      <Wrapper $small={small}>
        <GridLines>
          <GridLine />
          <GridLine />
          <GridLine />
          <GridLine />
          <GridLine />
        </GridLines>
        {chartContents}
      </Wrapper>
    );
  }
);
